import React from 'react';

export default function ContactData(props) {
    return (
        <>
        <p>
            <i className={`fa fa-${props.icon}`}></i>
            <strong>{props.title}</strong>
            {props?.detail?.map((item, index) => (
                <span className={`detail${index + 1}`} key={`${item}_${index}`}>{item}</span>
            ))}
        </p>
        
        {/* // <li>
        //     <div className="icon-holder">
        //         <span>
        //             <i className={`fa fa-${props.icon}`} />
        //         </span>
        //     </div>
        //     <div className="text-holder">
        //         {props?.detail?.map((item, index) => (
        //             <p className={`detail${index + 1}`} key={`${item}_${index}`}>{item}</p>
        //         ))}
        //     </div>
        // </li> */}
        </>
    );
}
